import Insurance from './Insurance';

export default Insurance;


// WEBPACK FOOTER //
// ./src/scenes/DeliveryMethods/DeliveryMethodDetail/components/Insurance/index.tsx